<div class="toast-container position-fixed top-0 end-0 p-3" style="z-index: 1200;">
  <ngb-toast
    *ngFor="let toast of toastService.toasts"
    [class]="toast.classname"
    [autohide]="true"
    [delay]="toast.delay"
    (hidden)="toastService.remove(toast)">
    {{ toast.text }}
  </ngb-toast>
</div>
